import API from "./index"

export const createPremiere = (data) => API.post(`/premieres`, data)
export const getPremieres = () => API.get('/performances/premieres')
export const deletePremiere = (id) => API.delete(`/premieres/${id}`)